import React, { useEffect, useMemo } from 'react'
import useTranslation from '../../../i18n/useTranslation'
import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components'
import moment from 'moment-timezone'
import { useLazyQuery, gql } from '@apollo/client'
import FilterBadge from '../../../common/FilterBadge'
const TestDateFilter = (props) => {
  const { translate } = useTranslation()
  const { setTestDate, testDate = [], servicesFilters = [] } = props
  const [getActivities, { data: dataActivities }] = useLazyQuery(
    gql`
      query (
          $serviceIds: [String!]
          $kinds: [String!]
          $from: DateTime
          $to: DateTime
      ) {
        allActivities(
            kinds: $kinds,
            serviceIds: $serviceIds
            from: $from,
            to: $to
        ){
            ... on Test {
              id
              name
              kind
              tbd
              startDate
              endDate
              busy
              serviceId
              registrationDate
              scoreReleaseDate
              isDisabled
            }
            ... on Event {
                id
                name
                kind
                tbd
                startDate
                endDate
                busy
                description
            }
        }
      }
    `,
    { variables: { serviceIds: servicesFilters, kinds: ['test'] } }
  )

  useEffect(() => {
    getActivities({ variables: { serviceIds: servicesFilters, kinds: ['test'] } })
    // eslint-disable-next-line
  }, [servicesFilters])

  const testDates = useMemo(
    () => {
      return dataActivities?.allActivities || []
    }, [dataActivities]
  )

  const selectorData = testDates
    ? testDates
      .map((item) => ({ name: item.name, id: item.startDate, startDate: item.startDate }))
      .sort((a, b) => moment(a.startDate).valueOf() - moment(b.startDate).valueOf())
    : []
  return (
    <CheckboxSelector
      direction='bottom'
      setDataFilters={setTestDate}
      dataFilters={testDate}
      data={selectorData}
      typeFilter='testDateSelector'
      strings={{
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }}
    >
      <FilterBadge
        title={translate('plans.testDate')}
        options={selectorData}
        selectedIds={testDate}
        onClearFilters={() => setTestDate([])}
      />
    </CheckboxSelector>
  )
}

export default TestDateFilter
